import React, { PureComponent } from 'react'
import { Grid, Paper, Table, TableHead, TableCell, TableBody, TableRow } from '@material-ui/core'

import { hasAccess } from '../../utils/api'
import EditableHOCWrapper from '../../containers/HOC/EditableHOC'
import LeaflyAccountItem from './LeaflyAccountItem'

const LeaflyAccountItemEditable = EditableHOCWrapper(LeaflyAccountItem)

class LeaflyAccounts extends PureComponent {
  render() {
    const { leafly = {}, lastModified, shopsList } = this.props
    const { onSave, onDelete } = this.props

    return (
      <Grid container>
        <Grid className="unversalScroll" item xs={12} sm={12} md={12} lg={12}>
          <Paper>
            <div className="table-scroll cell-padd-remove">
              <Table>
                <TableHead>
                  <TableRow>
                    <TableCell>Shop</TableCell>
                    <TableCell>Leafly Dispensary Key</TableCell>
                    <TableCell>Last Sync</TableCell>
                    <TableCell>Environment</TableCell>
                    <TableCell>Sync Status</TableCell>
                    {hasAccess() ? <TableCell>Actions</TableCell> : null}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {shopsList &&
                    shopsList.values &&
                    shopsList.values.length &&
                    shopsList.values.map((shop, index) => {
                      const dataToEdit = leafly[shop.id]
                      return (
                        <LeaflyAccountItemEditable
                          key={index}
                          shop={shop}
                          onSave={onSave(shop.id)}
                          dataToEdit={dataToEdit || { shopId: shop.id }}
                          lastModified={lastModified}
                          onDelete={onDelete}
                        />
                      )
                    })}
                </TableBody>
              </Table>
            </div>
          </Paper>
        </Grid>
      </Grid>
    )
  }
}

export default LeaflyAccounts



// WEBPACK FOOTER //
// ./src/components/Leafly/LeaflyAccounts.js